export default __webpack_public_path__ + "8a52d9c12a9c7e238a766e0321d4a86b.png";